import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"; // Import your configured axios instance
import "./UsersList.css"; // Import the CSS file
import { formatDate } from "../../utils/Utilities.js";
import { useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";

const GetManifestByDate = () => {
  const handleRedirect = () => {
    navigate("/manifestcreation");
  }
  const [manifest, setManifest] = useState([]); // To store list of manifest
  const [loading, setLoading] = useState(false); // Set loading initially to false
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [fromDate, setFromDate] = useState(""); // To store the from_date value
  const [toDate, setToDate] = useState(""); // To store the to_date value
  const manifestPerPage = 10; // Number of manifest per page
  const axiosPrivate = useAxiosPrivate();
  const GET_MANIFEST_BY_DATE_URL = "api/get-manifest-by-date"; // Replace with the correct API endpoint to fetch manifest

  const navigate = useNavigate();
  const handleViewClick = (manifestNumber) => {
    // Navigate to the GetFranchise component with employeeId as a URL parameter
    window.open(`/ManifestDetails/${manifestNumber}`, '_blank');
  };

  const handleEditClick = (manifestNumber) => {
    // Navigate to the GetFranchise component with employeeId as a URL parameter
    window.open(`/UpdateManifestCreation/${manifestNumber}`, '_blank');
  };
  // Fetch manifest based on from_date and to_date
  const fetchManifest = async (fromDate, toDate) => {
    setLoading(true); // Start loading spinner
    try {
      const fromDate_Formated = formatDate(fromDate);
      const toDate_Formated = formatDate(toDate);
      const data = {
        franchise_id: 1,
        from_date: fromDate_Formated,
        to_date: toDate_Formated,
      };

      const response = await axiosPrivate.get(GET_MANIFEST_BY_DATE_URL, {
        params: data,
      });

      setManifest(response.data); // Store the list of manifest into the state
      setLoading(false); // Stop loading spinner
      setError(null); // Clear any previous error
    } catch (error) {
      console.error("Error fetching manifest:", error);
      setError("Failed to load manifest");
      setLoading(false); // Set loading to false even if there is an error
    }
  };

  // Handle the search button click to fetch data with the new dates
  const handleSearch = () => {
    if (fromDate && toDate) {
      fetchManifest(fromDate, toDate);
      setError(null); // Clear the error if dates are valid
    } else {
      setError("Please enter both from and to dates."); // Show error if dates are missing
    }
  };

  // Paginate manifest
  const indexOfLastManifest = currentPage * manifestPerPage;
  const indexOfFirstManifest = indexOfLastManifest - manifestPerPage;
  const currentmanifest = manifest.slice(indexOfFirstManifest, indexOfLastManifest);

  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(manifest.length / manifestPerPage);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <>


      <section className="newsections">
        <br />

        <div className="newwrap">
          <div className="d-flex align-items-center">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">+ Create Manifest</button>
          </div>
          <h3>Manifest List</h3><br></br>

          {/* Date Filters and Search Button */}
          <center>
            <div className="search-filters newfilter">
              <label htmlFor="fromDate">From Date :</label>
              <input
                type="date"
                id="fromDate"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
              <label htmlFor="toDate">To Date :</label>
              <input
                type="date"
                id="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
              <br />
              <button onClick={handleSearch} className="btn scanbutton">Search</button>
            </div>
          </center>

          {/* Show error message if both dates are not provided */}
          {error && (
            <div className="error-message">
              <div className="error">{error}</div>
              {/* Show the search filters again below the error */}
            </div>
          )}

          {/* Show the table for displaying manifest only when there are results */}
          {manifest.length > 0 && !error && (
            <>
              <table border="1" id="customers">
                <thead>
                  <tr>
                    {/* <th>manifest id</th> */}
                    {/* <th>franchise_id</th> */}
                    <th> Date</th>
                    <th>Manifest number</th>
                    {/* <th> destination id</th> */}
                    {/* <th> destination franchise code</th> */}
                    <th>Destination franchise</th>
                    <th>No. of Cons.</th>
                    <th>Weight</th>
                    <th>Status</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {currentmanifest.map((manifest) => (
                    <tr key={manifest.manifest_id}>
                      {/* <td>{manifest.manifest_id}</td> */}
                      {/* <td>{manifest.franchise_id}</td> */}
                      <td>{manifest.manifest_date}</td>
                      <td>{manifest.manifest_number}</td>
                      {/* <td>{manifest.manifest_destination_id}</td> */}
                      {/* <td>{manifest.manifest_destination_franchise_code}</td> */}
                      <td>{manifest.manifest_destination_franchise_name}</td>
                      <td>{manifest.total_consignments}</td>
                      <td>{manifest.weight}</td>
                      <td>{manifest.current_status}</td>
                      <td className="d-flex justify-content-start">
                        <button
                          type="button"
                          className="btn btn-primary button-space btn-ico"
                          onClick={() => handleViewClick(manifest.manifest_number)}
                        >
                          <i className="bx bxs-show icon"></i>
                        </button>
                        <button type="button" className="btn btn-warning btn-ico" onClick={() => handleEditClick(manifest.manifest_number)}>
                          <i className="bx bxs-edit icon"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination - only show if there are multiple pages */}
              {totalPages > 1 && (
                <div className="pagination">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      disabled={currentPage === index + 1}>
                      {index + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}

          {/* If no manifest and error isn't shown, display a "No results" message */}
          {manifest.length === 0 && !loading && !error && (
            <div className="no-results">
              <p>No manifest found for the selected date range.</p>
            </div>
          )}
        </div>
      </section>
      <TopBar />
    </>
  );
};

export default GetManifestByDate;
